import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import ImageUpload from './ImageUpload';

const WithControllerImageUpload = ({ control, name, id, fileInfo, validation }) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => (
        <ImageUpload error={error} value={value} onChange={onChange} id={id} fileInfo={fileInfo} />
      )}
    />
  );
};

export default WithControllerImageUpload;
